import "./UsersSettings.css";

import { useState } from "react";
import { regUses } from "../../axios_with_token";

export default function UsersSettings({}){
    const {regUse, DefaultResponse} = regUses();
    return <DefaultResponse>
        <h1>user settings</h1>

    </DefaultResponse>;
}